/**
 * Fetch a lightweight version token for a sport projections feed.
 * This is intentionally tiny so we can poll frequently without heavy load.
 */
export default async function FetchFeedVersion(sport, shrk = 0) {
  if (!sport) return null;

  const safeSport = String(sport).toLowerCase();
  const params = new URLSearchParams();
  if (shrk !== undefined && shrk !== null) {
    params.set("shrk", String(shrk));
  }

  const query = params.toString();
  const url = `/wp-json/wagedwar/v1/feed-version/${encodeURIComponent(safeSport)}${query ? `?${query}` : ""}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching feed version:', error);
    return null;
  }
}
